import React, { useEffect, useState } from 'react';
import { Nav, INavLink } from '@fluentui/react/lib/Nav';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import { darkBlueTheme } from '../AppGlobals';

interface Props {
    environment: "LIVE" | "TEST";
    onEnvironmentChange: (env: "LIVE" | "TEST") => void;
    onCloseMenu?: () => void;
}

export const ZedXMainMenu: React.FC<Props> = ({ environment, onEnvironmentChange, onCloseMenu }) => {
    const imagesRoot: string = process.env.REACT_APP_ZedXImagesRoot!;
    const demoUrl: string = process.env.REACT_APP_DEMO_PORTAL_URL || "";


    const getInitialSelection = (): string => {
        const params = new URLSearchParams(window.location.search);
        const envParam = params.get("env");

        if (envParam === "LIVE") return "live";
        if (envParam === "TEST") return "training";

        return environment === "TEST" ? "training" : "live";
    };

    const [selectedKey, setSelectedKey] = useState<string>(getInitialSelection());

    useEffect(() => {
        const url = new URL(window.location.href);
        const envParam = url.searchParams.get("env");

        if (envParam === "LIVE") {
            setSelectedKey("live");
            onEnvironmentChange("LIVE");

            // remove param so it doesn't keep overriding
            url.searchParams.delete("env");
            window.history.replaceState({}, "", url.toString());
        }
        else if (envParam === "TEST") {
            setSelectedKey("training");
            onEnvironmentChange("TEST");

            // remove param
            url.searchParams.delete("env");
            window.history.replaceState({}, "", url.toString());
        }
        else {
            // Normal behavior
            setSelectedKey(environment === "TEST" ? "training" : "live");
        }
    }, [environment]);

    const handleClick = (key: string) => {

        setSelectedKey(key);

        if (key === "live") {
            onEnvironmentChange("LIVE");
        }
        else if (key === "training") {
            onEnvironmentChange("TEST");
        }

        // Close mobile menu if callback provided
        if (onCloseMenu) {
            onCloseMenu();
        }
    };

    const navLinks: INavLink[] = [
        {
            name: 'Live Account',
            key: 'live',
            url: '',
            data: { color: '28A745' }, // green
            onClick: () => handleClick("live")
        },
        {
            name: 'Training Account',
            key: 'training',
            url: '',
            data: { color: 'F59E0B' }, // orange
            onClick: () => handleClick("training")
        },
        {
            name: 'Demo Account',
            key: 'demo',
            url: '',
            data: { color: '3399FF' }, // blue
            onClick: () => {
                openDemo();
                if (onCloseMenu) onCloseMenu();
            }
        }
    ];

    // Render small colored square
    const renderColorIcon = (color: string) => {
        return (
            <img
                width="10"
                height="10"
                style={{ marginRight: '8px', borderRadius: '2px' }}
                src={`https://placehold.co/10x10/${color}/${color}`}
            />
        );
    };

    const openDemo = () => {
        if (demoUrl) {
            //window.open(demoUrl, "_blank");
            window.location.href = demoUrl;
        }
    };

    return (
        <ThemeProvider theme={darkBlueTheme}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                {/* Logo */}
                <div
                    style={{
                        width: '100%',
                        paddingTop: '0',
                        paddingBottom: '25px',
                        paddingLeft: '15px',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <img
                        src={`${imagesRoot}/leftnav/LeftMenu-ZedXMainMenu.png`}
                        alt="ZedX"
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />
                </div>

                {/* Navigation */}
                <Nav
                    selectedKey={selectedKey}
                    groups={[{ links: navLinks }]}
                    onRenderLink={(link) => (
                        <span style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            {renderColorIcon(link.data?.color)}
                            <span>{link.name}</span>
                        </span>
                    )}
                />

                {/* Demo Launch Box (only in STANDARD build) */}
                {demoUrl && (
                    <div
                        onClick={openDemo}
                        style={{
                            margin: "20px 10px",
                            padding: "12px 14px",
                            background: "#E6F2FF",
                            border: "1px solid #B3D7FF",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "all 0.2s"
                        }}
                    >
                        <div style={{ fontWeight: 600, color: "#0F5EA8" }}>
                            Try Demo Account
                        </div>
                        <div style={{ fontSize: "12px", color: "#333", marginTop: 4 }}>
                            Try our demo system with quality demo data. No registration required
                        </div>
                    </div>
                )}

            </div>
        </ThemeProvider>
    );
};